import { createElementBlock as l, openBlock as o, createElementVNode as C } from "vue";
const e = {
  width: "16",
  height: "17",
  viewBox: "0 0 16 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-ftva-outlook"
};
function n(i, t) {
  return o(), l("svg", e, t[0] || (t[0] = [
    C("path", {
      d: "M9.90332 3.89259V7.02231L10.9982 7.71088C11.0377 7.71937 11.0786 7.71937 11.1182 7.71088L15.8256 4.53716C15.8222 4.38314 15.7658 4.23498 15.666 4.1176C15.5662 4.00022 15.4291 3.92077 15.2776 3.89259H9.90332Z",
      fill: "#0072C6"
    }, null, -1),
    C("path", {
      d: "M9.90362 8.18973L10.9019 8.87544C10.9486 8.90403 11.0023 8.91916 11.0571 8.91916C11.1118 8.91916 11.1655 8.90403 11.2122 8.87544C11.0408 8.97887 15.8253 5.8023 15.8253 5.8023V11.5543C15.8378 11.6709 15.8247 11.7887 15.7868 11.8997C15.749 12.0106 15.6874 12.112 15.6063 12.1966C15.5252 12.2812 15.4266 12.3471 15.3173 12.3897C15.2081 12.4322 15.0909 12.4504 14.9739 12.4429H9.90305L9.90362 8.18973ZM4.73562 6.74687C4.56977 6.74613 4.4068 6.79025 4.26396 6.87454C4.12112 6.95884 4.00372 7.08018 3.92419 7.22573C3.70709 7.61164 3.60293 8.05085 3.62362 8.49316C3.60106 8.93455 3.70536 9.37317 3.92419 9.75716C4.00334 9.89675 4.11784 10.0131 4.25617 10.0944C4.39451 10.1757 4.55181 10.2192 4.71228 10.2205C4.87275 10.2217 5.03072 10.1808 5.17033 10.1016C5.30994 10.0225 5.42627 9.90805 5.50762 9.76973C5.72449 9.38767 5.82666 8.95121 5.80191 8.51258C5.82667 8.06024 5.7279 7.60967 5.51619 7.20916C5.44033 7.06848 5.32759 6.95112 5.19007 6.86968C5.05255 6.78823 4.89545 6.74578 4.73562 6.74687Z",
      fill: "#0072C6"
    }, null, -1),
    C("path", {
      d: "M0 2.30288V14.5469L9.31429 16.5V0.500019L0 2.30288ZM6.23314 10.4949C6.05894 10.7405 5.82727 10.9399 5.55834 11.0754C5.28941 11.211 4.99139 11.2787 4.69029 11.2726C4.39677 11.2778 4.10634 11.2121 3.84369 11.0809C3.58104 10.9498 3.35394 10.7572 3.18171 10.5194C2.77329 9.94915 2.56896 9.25786 2.60171 8.55716C2.56705 7.82211 2.77507 7.09606 3.19371 6.49088C3.37026 6.24066 3.6056 6.03767 3.87902 5.89976C4.15244 5.76186 4.45556 5.69326 4.76171 5.70002C5.05307 5.69437 5.34137 5.76023 5.60138 5.89183C5.86138 6.02342 6.08517 6.21675 6.25314 6.45488C6.65748 7.03754 6.85834 7.73732 6.82457 8.44573C6.86033 9.17549 6.65226 9.8964 6.23314 10.4949Z",
      fill: "#0072C6"
    }, null, -1)
  ]));
}
const s = { render: n };
export {
  s as default,
  n as render
};
